import { createFileRoute } from '@tanstack/react-router';
import { FinanceReviewScreen } from '../../screens/finance/Review';

export const Route = createFileRoute('/finance/review')({
  component: FinanceReviewScreen,
});
